import * as angular from 'angular';

import { WidgetBase } from '../models';
import { Helper } from '../../common';
import { ApprovalTableConfiguration } from './approvalTable.configuration';
import { approvalTableWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class ApprovalTableWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: ApprovalTableConfiguration;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = {
            groupGuid: null,
            isUserVisible: true,
            isApprovedDateVisible: true
        };
    }

    getSeries() {
        return [{ guid: this.configuration.groupGuid, isBoundToGroup: this.configuration.isBoundToGroup }];
    }
}